import {
	SET_ACCESSES,
	SET_ACCESS,
	CLEAR_ACCESSES,
	CLEAR_ACCESS,
	ADD_ACCESS,
	UPDATE_ACCESS,
	REMOVE_ACCESS,
} from './actionTypes';

export const access = (state = {}, action) => {
	switch (action.type) {
		case SET_ACCESS:
			return action.payload;
		case UPDATE_ACCESS:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_ACCESS:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_ACCESSES:
			return action.payload;
		case ADD_ACCESS:
			return [...state, action.payload];
		case UPDATE_ACCESS:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_ACCESS:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_ACCESSES:
			return [];
		default:
			return state;
	}
};
